<ion-content class="forgot-pw-area">
  <div class="header-bloc">
    <div class="btn-return-b">
      <button class="return-btn" (click)="backto()"></button>
      <h1>{{ 'FORGOT_PW_PAGE.TITLE' | translate}}</h1>
    </div>
    <h3>{{ 'FORGOT_PW_PAGE.SUBTITLE' | translate}}</h3>
  </div>

  <form class="form-area" [formGroup]="resetPasswordForm">
    <div class="input-form-box">
      <label position="floating"
        >{{ 'FORM.LABELS.PASSWORD' | translate}}
      </label>
      <div class="inputForm">
        <input
          type="{{textTypeNewMdp}}"
          formControlName="new_password"
          class="input"
          placeholder="{{ 'FORM.PLACEHOLDER.NEW_PWD' | translate}}"
        />
        <a
          [ngClass]="{'show-password': textTypeNewMdp === 'password', 'hide-password': textTypeNewMdp === 'text' }"
          (click)="togglePasswordVisibility('textTypeNewMdp')"
        >
        </a>
      </div>
      <span
        *ngIf="f['new_password'].hasError('minlength')"
        class="error-message"
      >
        {{'FORM.VALID.PWD_MIN_LENGTH' | translate}}
      </span>
      <span
        *ngIf="submitted && f['new_password'].hasError('required')"
        class="error-message"
      >
        {{'FORM.VALID.PASSWORD_REQUIRED' | translate}}
      </span>
    </div>
    <div class="input-form-box">
      <label position="floating"
        >{{ 'FORM.LABELS.CONFIRM_PASSWORD' | translate}}
      </label>
      <div class="inputForm">
        <input
          type="{{textTypeConfirmPw}}"
          (input)="removeError()"
          class="input"
          formControlName="confirm_password"
          placeholder="{{ 'FORM.PLACEHOLDER.CONFIRM_PWD' | translate}} "
        />
        <a
          [ngClass]="{'show-password': textTypeConfirmPw === 'password', 'hide-password': textTypeConfirmPw === 'text' }"
          (click)="togglePasswordVisibility('textTypeConfirmPw')"
        >
        </a>
      </div>
      <span
        *ngIf="f['confirm_password'].hasError('minlength')"
        class="error-message"
      >
        {{'FORM.VALID.PWD_MIN_LENGTH' | translate}}
      </span>
      <span
        *ngIf="submitted &&f['confirm_password'].hasError('required')"
        class="error-message"
      >
        {{'FORM.VALID.PASSWORD_REQUIRED' | translate}}
      </span>
      <span
        *ngIf=" f['confirm_password'].hasError('mustMatch')"
        class="error-message"
      >
        {{'FORM.VALID.EMAIL_MISSMATCH' | translate}}
      </span>
    </div>
  </form>
  <div class="padding-bloc-btn">
    <app-button
      [innerText]="'BUTTONS.SAVE' | translate"
      [disabled]="isLoading"
      [loading]="isLoading"
      (onClick)="submitForm()"
    ></app-button>
  </div>
</ion-content>
